export enum VestingClaimErrorType {
  NotEnoughBalanceToPayForFees = 'NotEnoughBalanceToPayForFees',
  CanNotClaimBkn = 'CanNotClaimBkn',
  ErrorExecutionOutOfGas = 'ErrorExecutionOutOfGas',
  UserDeniedTransactionSignature = 'UserDeniedTransactionSignature',
  PanicContactWithSupport = 'PanicContactWithSupport',
  GenericError = 'GenericError'
}
